import { render } from "./CommessaDettaglio.vue?vue&type=template&id=6c3b31df&scoped=true"
import script from "./CommessaDettaglio.vue?vue&type=script&lang=js"
export * from "./CommessaDettaglio.vue?vue&type=script&lang=js"

import "./CommessaDettaglio.vue?vue&type=style&index=0&id=6c3b31df&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c3b31df"]])

export default __exports__